import { gql } from '@apollo/client';

export const GET_MASTER_DATA_COUNTRIES = gql`
  query masterDataCountries($where: MasterDataCountryBoolExp) {
    masterDataCountries(where: $where) {
      _id
      translations {
        code
        name
      }
    }
  }
`;

export const GET_MASTER_DATA_COUNTRY = gql`
  query masterDataCountry($_id: String!) {
    masterDataCountry(_id: $_id) {
      _id
    }
  }
`;
